import React, {useState} from 'react'
import {Button, Card, Image, message, Row, Space, Timeline, Typography} from "antd";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useMount} from "ahooks";
import {VscsApi} from "../../services/VscsApi";
import {ValueUtils} from "../../utils/ValueUtils";
import SimpleTips from "../../containers/SimpleTips";

const {Text, Paragraph} = Typography

const VscsPersonTimelinePage = () => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const personId = searchParams.get("id")

    const [hasMore, setHasMore] = useState(true)
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(0)
    const [person, setPerson] = useState({})
    const [timeline, setTimeline] = useState([])

    const [showPicture, setShowPicture] = useState(false)

    const requestData = () => {
        setLoading(true)
        VscsApi.personTimeline(personId, page)
            .onSuccess(data => {
                var _hasMore = data.length > 0;
                setHasMore(_hasMore)
                if (!hasMore) {
                    message.info("没有更多了")
                }
                setTimeline([...timeline, ...data])
                setPage(page + 1)
            })
            .onComplete(() => {
                setLoading(false)
            })
    }

    useMount(() => {
        VscsApi.person(personId)
            .onSuccess(setPerson)
        requestData()
    })

    const mapGender = (value) => {
        if (value === "-1") {
            return "未知"
        }
        if (value === "1") {
            return "女"
        }
        if (value === "0") {
            return "男"
        }
        return "无法识别"
    }

    return (
        <>
            <Card title={"基础人物"}
                  extra={<Button type="link"
                                 onClick={() => navigate('/vscs/person/faces?id=' + personId)}>全部照片</Button>}
                  style={{marginBottom: 16}}>
                <Space direction="vertical">
                    <Image
                        height={101}
                        width={101}
                        preview={false}
                        src={person.properties?.face.imageUrl}
                    />
                    <SimpleTips
                        tips={[
                            "#" + person.id,
                            "推测年龄：" + person.age,
                            "推测性别：" + mapGender(person.gender)
                        ]}
                    />
                </Space>
            </Card>

            <Card title={"时间轴"} extra={
                <Button onClick={() => setShowPicture(!showPicture)}>{showPicture ? "隐藏照片" : "显示照片"}</Button>
            }>

                <Timeline mode="left">
                    {
                        timeline.map(day =>
                            <Timeline.Item>
                                {day.left}
                                <Card size="small">
                                    <Timeline>
                                        {
                                            day.right.map(travelItem =>
                                                <Timeline.Item style={{paddingBottom: 5}}>
                                                    <Paragraph
                                                        style={{marginBottom: 0}}>{ValueUtils.formatDateOrEmpty(travelItem.startTime, "HH:mm:ss")} ~ {ValueUtils.formatDateOrEmpty(travelItem.endTime, "HH:mm:ss")}</Paragraph>
                                                    <Paragraph strong
                                                               style={{marginBottom: 0}}>{travelItem.venue.name}（{travelItem.venue.properties?.region?.name}）</Paragraph>
                                                    {
                                                        showPicture && <Space wrap>
                                                            {
                                                                travelItem.faces.map(personFace =>
                                                                    <Card size="small"
                                                                          style={{width: 110}}
                                                                          cover={<Image
                                                                              height={101}
                                                                              src={personFace.properties.face.imageUrl}
                                                                          />}>
                                                                        <Text style={{
                                                                            fontSize: 13,
                                                                            margin: 0
                                                                        }}>可能性：{personFace.similar}</Text>
                                                                    </Card>)
                                                            }
                                                        </Space>
                                                    }
                                                </Timeline.Item>)
                                        }
                                    </Timeline>
                                </Card>
                            </Timeline.Item>)
                    }
                </Timeline>

                {
                    hasMore && <Row justify="center">
                        <Button loading={loading} onClick={requestData}>更多</Button>
                    </Row>
                }
            </Card>
        </>
    )
}

export default VscsPersonTimelinePage